/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const SubmissionCalendarIcon = ({ 
  className = "h-7 w-7", 
  date = null,
  urgencyLevel = "normal", // "normal", "urgent", "critical"
  showPinkAccent = false 
}) => {
  // Get current date for overlay if not provided
  const displayDate = date || new Date().getDate();
  
  return (
    <div className="relative">
      <svg 
        className={className} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Submission calendar with date"
      >
        {/* Calendar base */}
        <rect 
          x="3" 
          y="4" 
          width="18" 
          height="18" 
          rx="2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none"
        />
        
        {/* Calendar header */}
        <path 
          d="M3 10h18" 
          stroke="currentColor" 
          strokeWidth="1.5"
        />
        
        {/* Calendar rings/holes */}
        <path 
          d="M8 2v4M16 2v4" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round"
        />
        
        {/* Minimal grid lines for dates */}
        <g opacity="0.3">
          <path d="M8 10v12" stroke="currentColor" strokeWidth="0.5" />
          <path d="M13 10v12" stroke="currentColor" strokeWidth="0.5" />
          <path d="M18 10v12" stroke="currentColor" strokeWidth="0.5" />
          <path d="M3 14h18" stroke="currentColor" strokeWidth="0.5" />  
          <path d="M3 18h18" stroke="currentColor" strokeWidth="0.5" />
        </g>
        
        {/* Simple date indicator */}
        <g opacity="0.7">
          <circle cx="12" cy="16" r="1.5" fill="currentColor" />
        </g>
        
        {/* Date number overlay - subtle and clean */}
        <text 
          x="12" 
          y="17.5" 
          textAnchor="middle" 
          fontSize="5" 
          fontFamily="monospace" 
          fill="white"
          fontWeight="600"
        >
          {displayDate}
        </text>
      </svg>
      
      {/* Pink urgency indicator dot */}
      <div className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-primary rounded-full border-2 border-white">
      </div>
    </div>
  );
};

SubmissionCalendarIcon.propTypes = {
  className: PropTypes.string,
  date: PropTypes.number,
  urgencyLevel: PropTypes.oneOf(['normal', 'urgent', 'critical']),
  showPinkAccent: PropTypes.bool,
};

export default SubmissionCalendarIcon;